import { render } from "./TestAccess.vue?vue&type=template&id=1a6fa52c&ts=true"
import script from "./TestAccess.vue?vue&type=script&lang=ts"
export * from "./TestAccess.vue?vue&type=script&lang=ts"

import exportComponent from "/runner/_work/OrderpadConfigurationWeb/OrderpadConfigurationWeb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__